import React from 'react';
import { StyledBox, StyledDrawerBox } from './styles';
import { Box, Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme } from '@mui/material';
import { NavBarProps } from './types';
import NavBarLogo from '../../assets/svgs/contigo_App_icono.svg';
import Logo from '../../assets/drawerLogo.png'
import MenuIcon from '@mui/icons-material/Menu';
import FlagIcon from '@mui/icons-material/Flag';
import ListAltIcon from '@mui/icons-material/ListAlt';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import GridViewIcon from '@mui/icons-material/GridView';
import EventIcon from '@mui/icons-material/Event';
import InterestsIcon from '@mui/icons-material/Interests';
import SosIcon from '@mui/icons-material/Sos';
import CampaignIcon from '@mui/icons-material/Campaign';
import { useNavigate } from 'react-router-dom';

const NavBar: React.FC<NavBarProps> = ({ active }) => {
    const [open, setOpen] = React.useState<boolean>(false);
    const theme = useTheme();
    const navigate = useNavigate();

    const DrawerList = (
        <StyledDrawerBox role="presentation">
            <Box textAlign="center">
                <img src={Logo} width="70%" style={{ padding: theme.spacing(2) }} alt="logo" />
            </Box>
            <Divider />
            <List>
                <ListItem key={"inicio"} disablePadding>
                    <ListItemButton onClick={() => navigate('/')}>
                        <ListItemIcon style={{ color: active === "inicio" ? "#ff8c12ff" : undefined }}>
                            <FlagIcon />
                        </ListItemIcon>
                        <ListItemText primary={"Inicio"} slotProps={{ primary: { fontWeight: active === "inicio" ? 600 : undefined, color: active === "inicio" ? "#2ac7b5" : undefined } }} />
                    </ListItemButton>
                </ListItem>
                <ListItem key={"servicios"} disablePadding>
                    <ListItemButton onClick={() => navigate("/services")}>
                        <ListItemIcon style={{ color: active === "servicios" ? "#ff8c12ff" : undefined }}>
                            <ListAltIcon />
                        </ListItemIcon>
                        <ListItemText primary={"Servicios y Beneficios"} slotProps={{ primary: { fontWeight: active === "servicios" ? 600 : undefined, color: active === "servicios" ? "#2ac7b5" : undefined } }} />
                    </ListItemButton>
                </ListItem>
                <ListItem key={"plataformas"} disablePadding>
                    <ListItemButton onClick={() => navigate("/platforms")}>
                        <ListItemIcon style={{ color: active === "plataformas" ? "#ff8c12ff" : undefined }}>
                            <GridViewIcon />
                        </ListItemIcon>
                        <ListItemText primary={"Plataformas"} slotProps={{ primary: { fontWeight: active === "plataformas" ? 600 : undefined, color: active === "plataformas" ? "#2ac7b5" : undefined } }} />
                    </ListItemButton>
                </ListItem>
                <ListItem key={"calendar"} disablePadding>
                    <ListItemButton onClick={() => navigate("/calendar")}>
                        <ListItemIcon style={{ color: active === "calendar" ? "#ff8c12ff" : undefined }}>
                            <EventIcon />
                        </ListItemIcon>
                        <ListItemText primary={"Calendario"} slotProps={{ primary: { fontWeight: active === "calendar" ? 600 : undefined, color: active === "calendar" ? "#2ac7b5" : undefined } }} />
                    </ListItemButton>
                </ListItem>
                {/* <ListItem key={"cultura"} disablePadding>
                    <ListItemButton onClick={() => navigate("/culture")}>
                        <ListItemIcon style={{ color: active === "cultura" ? "#ff8c12ff" : undefined }}>
                            <InterestsIcon />
                        </ListItemIcon>
                        <ListItemText primary={"Cultura"} slotProps={{ primary: { fontWeight: active === "cultura" ? 600 : undefined, color: active === "cultura" ? "#2ac7b5" : undefined } }} />
                    </ListItemButton>
                </ListItem> */}
                {/* <ListItem key={"emergencias"} disablePadding>
                    <ListItemButton onClick={() => navigate("/emergencies")}>
                        <ListItemIcon style={{ color: active === "emergencias" ? "#ff8c12ff" : undefined }}>
                            <SosIcon />
                        </ListItemIcon>
                        <ListItemText primary={"Emergencias"} slotProps={{ primary: { fontWeight: active === "emergencias" ? 600 : undefined, color: active === "emergencias" ? "#2ac7b5" : undefined } }} />
                    </ListItemButton>
                </ListItem> */}
                <ListItem key={"comunicados"} disablePadding>
                    <ListItemButton onClick={() => navigate("/communications")}>
                        <ListItemIcon style={{ color: active === "comunicados" ? "#ff8c12ff" : undefined }}>
                            <CampaignIcon />
                        </ListItemIcon>
                        <ListItemText primary={"Comunicados"} slotProps={{ primary: { fontWeight: active === "comunicados" ? 600 : undefined } }} />
                    </ListItemButton>
                </ListItem>
            </List>
        </StyledDrawerBox>
    );

    return (
        <StyledBox theme={theme}>
            <IconButton onClick={() => setOpen(true)} aria-label="Menu" size="large">
                <MenuIcon />
            </IconButton>
            <Drawer open={open} onClose={() => setOpen(false)}>
                {DrawerList}
            </Drawer>
            <Box margin={"auto"} textAlign="center">
                <img width={"25px"} src={NavBarLogo} alt="navbarIcon" />
            </Box>
            <Box display={"flex"}>
                <IconButton style={{ padding: theme.spacing(.75) }}>
                    <ManageSearchIcon />
                </IconButton>
                <IconButton style={{ padding: theme.spacing(.75) }}>
                    <MoreVertIcon />
                </IconButton>
            </Box>
        </StyledBox>
    )
}

export default NavBar;